import { render } from "./ApplyFor.vue?vue&type=template&id=fcaa8598&scoped=true"
import script from "./ApplyFor.vue?vue&type=script&lang=js"
export * from "./ApplyFor.vue?vue&type=script&lang=js"

import "./ApplyFor.vue?vue&type=style&index=0&id=fcaa8598&scoped=true&lang=css"

import exportComponent from "E:\\H5\\order_food\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcaa8598"]])

export default __exports__